// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import vueResource from 'vue-resource'
import VueLocalStorage from 'vue-localstorage'
import router from './router'
import Oidc from 'oidc-client'
import config from './appsettings.js'
import ElementUI from 'element-ui'
import store from './store'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/ru-RU'

Vue.config.productionTip = false

Vue.use(vueResource);
Vue.use(VueLocalStorage);
Vue.use(ElementUI, { locale })

Vue.prototype.$manager = new Oidc.UserManager({
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
  authority: `${config.IS_PREFIX}`,
  client_id: `${config.CLIENT_ID}`,
  redirect_uri: `${config.FE_PREFIX}/auth/callback`,
  post_logout_redirect_uri: `${config.FE_PREFIX}`,
  silent_redirect_uri: `${config.FE_PREFIX}/auth/silent-renew`,
  response_type: 'id_token token',
  scope: 'openid profile email roles hrc-api-main',
  accessTokenExpiringNotificationTime: 60,
  automaticSilentRenew: true,
  loadUserInfo: true,
  filterProtocolClaims: true
});

Vue.prototype.$gf = {
  getOptions() {
    return new Promise(function(resolve, reject) {
      let access_token = null;
      Vue.prototype.$manager.getUser().then(user => {
        if (user != null) {
          access_token = user.access_token;
          resolve({headers: {'Authorization': `Bearer  ${access_token}`}});
        } else {
          reject(Error("Not Authorized"));
        }
      })
    })
  },
  catchOptions() {
    console.log("User not found");
    router.push(config.WELCOME_URL);
    //Event.$emit('notAuthorized');
  },
  checkError(data) {
    console.log('Status: ' + data.status);
    if(data.status === 401) {
      Vue.prototype.$manager.removeUser().then(res => router.push(config.WELCOME_URL));
      console.log("User is found, but access_token is expired");
      //Event.$emit('notAuthorized');
    } else if (data.status === 403) {
      router.push(config.FORBIDDEN_URL);
    } else if (data.status === 404) {
      router.push(config.NOT_FOUND_URL);
    } else if (data.status === 500) {
      router.push(config.INTERNAL_SERVER_ERROR_URL);
    } else {
      this.errorToast(data.status)
    }
  },
  errorToast(error) {
    console.log("ERROR STATUS: " + error)
  },
}

window.Event = new Vue();
/*
  На всякий случай - метод преобразования даты-времени в формат ISO8601 при конверте в JSON с УКАЗАНИЕМ TimeZone-ы !!! (по-умолчанию - идет без зоны с конвертом в UTC)
  Date.prototype.toJSON = function() {
  var timezoneOffsetInHours = -(this.getTimezoneOffset() / 60); //UTC minus local time
  var sign = timezoneOffsetInHours >= 0 ? '+' : '-';
  var leadingZero = (timezoneOffsetInHours < 10) ? '0' : '';

  //It's a bit unfortunate that we need to construct a new Date instance
  //(we don't want _this_ Date instance to be modified)
  var correctedDate = new Date(this.getFullYear(), this.getMonth(),
      this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds());
  correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
  var iso = correctedDate.toISOString().replace('Z', '');

  console.log(iso + sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ':00');
  return iso + sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ':00';
}*/
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js